import { render, staticRenderFns } from "./BrowseDatasetMenu.vue?vue&type=template&id=06658776&"
import script from "./BrowseDatasetMenu.vue?vue&type=script&lang=ts&"
export * from "./BrowseDatasetMenu.vue?vue&type=script&lang=ts&"
import style0 from "./BrowseDatasetMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports